import React from "react";
import { Alert, Button, Paper, Stack, Typography } from "@mui/material";

export default function Step5Result({ registrationResult, onReset, onClose }) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6">Step 5: 登録完了</Typography>
        {registrationResult ? (
          <Alert severity="success" sx={{ width: '100%' }}>
            <Typography>登録処理が完了しました。</Typography>
            <Typography>新規登録: {registrationResult.inserted_count}件</Typography>
            <Typography>更新: {registrationResult.updated_count}件</Typography>
          </Alert>
        ) : (
          <Alert severity="warning">登録結果がありません。</Alert>
        )}
        <Stack direction="row" spacing={2}>
          <Button variant="contained" onClick={onReset}>初めからやり直す</Button>
          <Button variant="outlined" onClick={onClose}>ダイアログを閉じる</Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
